var exports = {
  "kL": "x31de4314--d31dbc--container",
  "Sl": "x31de4314--d31dbc--image",
  "h_": "x31de4314--d31dbc--description",
};

module.exports = exports;
